namespace $.$$ {
	$mol_style_define($bog_blitz_lobby, {
		No_game: {
			flex: {
				direction: 'column',
				grow: 1,
			},
			align: {
				items: 'center',
				self: 'center',
			},
			justify: {
				content: 'center',
			},
			gap: '1.5rem',
		},
		No_game_text: {
			font: { size: '1.5rem', weight: 600 },
			opacity: 0.6,
			textAlign: 'center',
		},
	})
}
